export interface DeviceMode {
  id: string;
  name: string;
  desc: string;
  icon: string;
}

export const DEVICE_MODES: DeviceMode[] = [
  { id: "gentle", name: "ソフト", desc: "低周波でゆったりリラックス", icon: "ri-heart-3-line" },
  { id: "pulse", name: "パルス", desc: "リズミカルな断続振動", icon: "ri-flashlight-line" },
  { id: "wave", name: "ウェーブ", desc: "波のように強弱を繰り返す", icon: "ri-water-flash-line" },
  { id: "surge", name: "ビルド", desc: "徐々に高まるクライマックス", icon: "ri-line-chart-line" },
  { id: "random", name: "ランダム", desc: "予測不能なサプライズ体験", icon: "ri-shuffle-line" },
];